import moment from "moment-timezone";
import { types } from "../actions";


const date = new Date();
const timeZone = moment.tz.guess();
const formattedDate = moment(date).format("MMM D,");
const formattedTime = moment(date).tz(timeZone).format("h:mm:ss A z");

const initialState = {
  incidentsList: [],
  selectedIncidentList: [],
  lastUpdated: `${formattedDate} ${formattedTime}`,
};

const availableIncidentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_AVAILABLE_INCIDENTS:
      if (action?.payload && Array.isArray(action?.payload)) {
        return {
          ...state,
          incidentsList: action.payload.filter(
            (item) => item?.status?.toLowerCase() === "unresolved"
          ),
        };
      } else {
        return state;
      }

    case types.ADD_SELECTED_AVAILABLE_INCIDENT:
      if (action?.payload) {
        const exists = state.selectedIncidentList?.some(
          (item) => item?.id === action?.payload?.id
        );
        if (exists) {
          return state;
        }
        return {
          ...state,
          selectedIncidentList: [
            ...state?.selectedIncidentList,
            action.payload,
          ],
        };
      } else {
        return state;
      }

    case types.REMOVE_SELECTED_AVAILABLE_INCIDENT:
      if (action?.payload) {
        return {
          ...state,
          selectedIncidentList: state.selectedIncidentList.filter(
            (item) => item?.id !== action?.payload?.id
          ),
        };
      } else {
        return state;
      }

    case types.ADD_BULK_SELECTED_AVAILABLE_INCIDENTS:
      if (action?.payload && Array.isArray(action?.payload)) {
        return {
          ...state,
          selectedIncidentList: action.payload,
        };
      } else {
        return state;
      }

    case types.REMOVE_BULK_SELECTED_AVAILABLE_INCIDENTS:
      return {
        ...state,
        selectedIncidentList: [],
      };

    case types.ADD_LAST_UPDATED_TIME:
      return {
        ...state,
        lastUpdated: action.payload,
      };

    default:
      return state;
  }
};

export default availableIncidentsReducer;
